import React from 'react';

import jira from 'src/lib/api/jira';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

import { useSelectedIssueTypes, useSelectedProjects } from './RuleFormContext';

const IssueTypesSelect = ({ ...props }) => {
  const selectedProjects = useSelectedProjects();
  const selectedIssueTypes = useSelectedIssueTypes();
  const loadOptions = async () => {
    if (selectedProjects?.length) {
      const { projects } = await jira.getCreateMetadata(selectedProjects, selectedIssueTypes);
      const all = projects.flatMap(p => p.issuetypes || []);
      const uniq = all.reduce((acc, val) => Object.assign(acc, { [val.id]: val }), {});
      return Object.values(uniq).map(({ id, name, iconUrl }) => ({
        id,
        icon: iconUrl,
        label: name,
      }));
    } else {
      return [];
    }
  };

  return (
    <GenericAsyncSelect
      loadOptions={loadOptions}
      placeholder="Select Issue type..."
      hasIcons
      {...props}
    />
  );
};

export default IssueTypesSelect;
